import { configureStore } from "@reduxjs/toolkit";
import faderReducer from "./states/fader/faderSlice";
import statusReducer from "./states/status/statusSlice";
import appConfReducer from "./states/appConf/appConfSlice";
import pegaReducer from "./states/pega/pegaSlice";
import contentReducer from "./states/content/contentSlice";
import queryParamsReducer from "./states/queryParams/queryParamsSlice";

export const store = configureStore({
  reducer: {
    status: statusReducer,
    appConf: appConfReducer,
    fader: faderReducer,
    pega: pegaReducer,
    content: contentReducer,
    queryParams: queryParamsReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
